import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { postClient, patchClient } from "@/api/clients";

export default function ClientForm({ client, onSave, venueId }) {
    const [firstName, setFirstName] = useState(client?.firstName || "");
    const [lastName, setLastName] = useState(client?.lastName || "");
    const [tel, setTel] = useState(client?.tel || "");
    const [email, setEmail] = useState(client?.email || "");
    const [isLoginEnabled, setIsLoginEnabled] = useState(client?.enableLogin || false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (isLoginEnabled && !email.trim()) {
            setError("Email is required when login is enabled.");
            return;
        }

        setLoading(true);

        const payload = {
            first_name: firstName,
            last_name: lastName,
            tel,
            email,
            login_enabled: isLoginEnabled,
            venue_id: venueId,
        };

        const response = client?.id
            ? await patchClient(client.id, payload)
            : await postClient(payload);

        console.log('res',response)
        setLoading(false);
        if (response) onSave?.();
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <Label htmlFor="firstName">First Name</Label>
                <Input id="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
            </div>

            <div>
                <Label htmlFor="lastName">Last Name</Label>
                <Input id="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
            </div>

            <div>
                <Label htmlFor="tel">Telephone</Label>
                <Input id="tel" value={tel} onChange={(e) => setTel(e.target.value)} required />
            </div>

            <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required={isLoginEnabled} />
            </div>

            <div className="flex items-center justify-between">
                <Label htmlFor="login-enabled">Allow Login</Label>
                <Switch id="login-enabled" checked={isLoginEnabled} onCheckedChange={setIsLoginEnabled} />
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}

            <Button type="submit" disabled={loading}>
                {client?.id ? "Update Client" : "Create Client"}
            </Button>
        </form>
    );
}
